import React, {useState} from "react";
import Tippy from "@tippyjs/react";
import {roundArrow} from "tippy.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HomeIcon, SettingsIcon, SunIcon, MoonIcon, LessIcon, GreaterIcon, LensIcon, TileIcon, UsersIcon } from "../assets/icons";
import { faCartShopping, faEye, faRectangleList, faClipboardQuestion, faChartSimple, faLink, faUniversity, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import {Link} from "react-router-dom";
import ProfileBox from "../components/main/ProfileBox";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { menuSelector} from "../redux/slices/menuSlice";
import SidebarPanel from "../components/main/SidebarPanel";
import useAuth from "../hooks/useAuth";
import SearchBar from "../components/main/SearchBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthApi from "../api/AuthApi";
import {useDispatch} from "react-redux";
import CartBar from "../components/main/CartBar";
import RequestApi from "../api/RequestApi";
import {Skeleton} from 'antd';
import {IsMobile} from "../func/Tools";

const MainLayout = () => {

    const navigate = useNavigate();
    const [contactEmail, setContactEmail] = useState("");
    const [contactPhone, setContactPhone] = useState("");

    // check auth
    axios.interceptors.response.use(response => response, error => {
        if (error.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('roles');
            setAuth(false)
            navigate('/auth/login');
        }
    })

    const { isAuthenticated, setAuth , roles, setRoles, isAdminOrManagerOrPartner, isCurator } = useAuth();
    const location = useLocation();
    const menu = useSelector(menuSelector);
    const [isThemeDark, setIsThemeDark] = React.useState(() => {
        const saved = localStorage.getItem("isThemeDark");
        const initialValue = saved === "1";
        return initialValue || false;
    });
    const [isOpenSidebar, setIsOpenSidebar] = React.useState(window.innerWidth >= 1280);
    const rootElement = document.documentElement;
    const bodyElement = document.body;

    React.useEffect(() => {

        isThemeDark ? rootElement.classList.add('dark') : rootElement.classList.remove('dark');
        isOpenSidebar ? bodyElement.classList.add('is-sidebar-open') : bodyElement.classList.remove('is-sidebar-open');

        localStorage.setItem('isThemeDark', isThemeDark ? "1" : "0");

    }, [isThemeDark, isOpenSidebar])

    React.useEffect(() => {

        if (menu.items.length > 0 && window.innerWidth >= 1280) {
            setIsOpenSidebar(true);
        } else {
            setIsOpenSidebar(false);
        }
        //if (window.innerWidth > 1280) {
            //setIsOpenSidebar(menu.items.length > 0);
       // }
    }, [menu])

    React.useEffect(() => {
        AuthApi.ping().then((data) => {
            if (data !== undefined) {
                setRoles(data.roles);
            }
        });
        // get options for header
        setContactEmail(localStorage.getItem('contactEmail') ?? '');
        setContactPhone(localStorage.getItem('contactPhone') ?? '');
        RequestApi.get('private/setting').then(res => {
            if (res.status === RequestApi.STATUS_SUCCESS && res.content.items !== undefined) {
                res.content.items.forEach((item: any) => {
                    if (item.code === 'contactEmail') {
                        setContactEmail(item.value);
                        localStorage.setItem('contactEmail', item.value);
                    }
                    if (item.code === 'contactPhone') {
                        setContactPhone(item.value);
                        localStorage.setItem('contactPhone', item.value);
                    }
                });
            }
        });
    }, [])

    const changeThemeHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
        setIsThemeDark(!isThemeDark);
    }
    const changeSidebarHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
        setIsOpenSidebar(!isOpenSidebar);
    }

    return (
        isAuthenticated ?
        <div className="min-h-100vh flex grow bg-slate-50 dark:bg-navy-900">
            {/*<div className="app-preloader fixed z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
            </div>*/}
            <div className="sidebar print:hidden">
                <div className="main-sidebar">
                    <div className="flex h-full w-full flex-col items-center border-r border-slate-150 bg-white dark:border-navy-700 dark:bg-navy-800">
                        <div className="flex pt-4">
                            <Link to="/">
                                <img className="h-11 w-11 transition-transform duration-500 ease-in-out hover:rotate-[360deg]" src="/icon.png" alt="logo"/>
                            </Link>
                        </div>

                        <div className="is-scrollbar-hidden flex grow flex-col space-y-4 overflow-y-auto pt-6">
                            <Tippy touch={false} content="Главная" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:bg-navy-600 dark:text-accent-light dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90">
                                  <HomeIcon />
                                </Link>
                            </Tippy>
                            <Tippy touch={false} content="Каталог курсов" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/catalog" onClick={() => IsMobile() && setIsOpenSidebar(false)} className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <TileIcon />
                                </Link>
                            </Tippy>
                            <Tippy touch={false} content="Мои курсы" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/catalog/category/my" onClick={() => IsMobile() && setIsOpenSidebar(false)} className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <FontAwesomeIcon size={'xl'} icon={faRectangleList} />
                                </Link>
                            </Tippy>
                            <Tippy touch={false} content="Заказы" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/orders" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <FontAwesomeIcon size={'xl'} icon={faCartShopping} />
                                </Link>
                            </Tippy>
                            <Tippy touch={false} content="Результаты тестирований" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/testing" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <FontAwesomeIcon size={'xl'} icon={faClipboardQuestion} />
                                </Link>
                            </Tippy>
                            { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) &&
                                <Tippy touch={false} content="Доступы" arrow={roundArrow} animation="shift-away" placement="right">
                                    <Link to="/cabinet/accesses" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                        <FontAwesomeIcon size={'xl'} icon={faEye} />
                                    </Link>
                                </Tippy>
                            }
                            { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) &&
                            <Tippy touch={false} content="Пользователи" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/users" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <UsersIcon />
                                </Link>
                            </Tippy>
                            }
                            { (isAdminOrManagerOrPartner || isCurator) &&
                            <Tippy touch={false} content="Активность пользователей" arrow={roundArrow} animation="shift-away" placement="right">
                                <Link to="/cabinet/statistic" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <FontAwesomeIcon icon={faChartSimple} size={'lg'}/>
                                </Link>
                            </Tippy>
                            }
                            { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) &&
                                <Tippy touch={false} content="Заказы-ссылки" arrow={roundArrow} animation="shift-away" placement="right">
                                    <Link to="/cabinet/link-orders" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                        <FontAwesomeIcon icon={faLink} size={'lg'}/>
                                    </Link>
                                </Tippy>
                            }
                            { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) &&
                                <Tippy touch={false} content="Организации" arrow={roundArrow} animation="shift-away" placement="right">
                                    <Link to="/cabinet/organizations" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                        <FontAwesomeIcon icon={faUniversity} size={'lg'}/>
                                    </Link>
                                </Tippy>
                            }
                            { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER') || roles.includes('ROLE_CURATOR')) &&
                                <Tippy touch={false} content="Документы по обучению" arrow={roundArrow} animation="shift-away" placement="right">
                                    <Link to="/cabinet/applications-management" className="tooltip-main-sidebar flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                        <FontAwesomeIcon icon={faNewspaper} size={'lg'}/>
                                    </Link>
                                </Tippy>
                            }
                        </div>

                        <div className="flex flex-col items-center space-y-3 py-3">
                            { roles.includes('ROLE_ADMIN') &&
                                <Link to="/cabinet/setting/options" className="flex h-11 w-11 items-center justify-center rounded-lg outline-none transition-colors duration-200 hover:bg-primary/20 focus:bg-primary/20 active:bg-primary/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                    <SettingsIcon />
                                </Link>
                            }

                            <ProfileBox />

                        </div>
                    </div>
                </div>
                <SidebarPanel setIsOpenSidebar={() => setIsOpenSidebar(!isOpenSidebar)}/>
            </div>
            <nav className="header print:hidden">
                <div className="header-container relative flex w-full bg-white dark:bg-navy-700 print:hidden">
                    <div className="flex w-full items-center justify-between">
                        <div className="h-7 w-7" onClick={changeSidebarHandler}>
                            <button
                                className="sidebar-toggle ml-0.5 flex h-7 w-7 flex-col justify-center space-y-1.5 text-primary outline-none focus:outline-none dark:text-accent-light/80">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                        <div className={'flex mob-block'}>
                            {/*<Skeleton.Button active={true} style={{ width: 500, height: 20 }} />*/}
                            <div className={'mr-2 mob-hidden'}>Техподдержка: </div>
                            <div><span className={'font-bold mob-hidden'}>Тел.:</span> <a className={'mr-2 hover:underline'} href={'tel:' + contactPhone.replace(/\D/g, '')}>{contactPhone}</a></div>
                            <div><span className={'font-bold mob-hidden'}>E-mail:</span> <a className={'hover:underline'} href={'mailto:' + contactEmail}>{contactEmail}</a></div>
                        </div>
                        <div className="-mr-1.5 flex items-center space-x-2">

                            <CartBar/>
                            {/*Mobile Search Toggle*/}

                            {/*Main Searchbar*/}
                            <SearchBar/>

                            {/*Dark Mode Toggle*/}
                            {/*<button onClick={changeThemeHandler} className="darkmode-toggle btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                                {
                                    isThemeDark ? <MoonIcon /> : <SunIcon />
                                }
                            </button>*/}

                        </div>
                    </div>
                </div>
            </nav>
            <main className="main-content w-full px-[var(--margin-x)] pb-8">
                <Outlet/>
            </main>
        </div>
            :
            <Navigate to="/auth/login" state={{ from: location }} replace />
    )
}

export default MainLayout;
